<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ $t('message.sts') }} {{ form.codigo }}</h3>
            </div>
        </div>
        <div class="layout__main">
            <div class="layout__main-form">
                <div class="card">
                    <div class="card__content">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="select-field">
                                    <select @change="cambiarTipo" :disabled="!editable" id="tipo" v-model="form.tipo">
                                        <option value="C">{{ $t('message.caja') }}</option>
                                        <option value="M">{{ $t('message.maquina') }}</option>
                                    </select>
                                    <label for="tipo">{{ $t('message.tipo') }}</label>
                                    <span v-if="errores.tipo" class="helper-text text-danger" slot="helper">
                                        <strong>{{ errores.tipo[0] }}</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field v-model="form.codigo" id="codigo" placeholder="##">
                                        <span>{{ $t('message.codigo') }}</span>
                                        <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.codigo[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <p>
                                    <label for="todasLineas">
                                        <input @change="changeTodasLineas" type="checkbox" id="todasLineas" v-model="todasLineas"> <span>{{ $t('message.todasLineas') }}</span>
                                    </label>
                                </p>
                            </div>
                            <div v-show="!todasLineas" class="col-xs-12 col-md-6">
                                <div class="form-field select2">
                                    <div class="select2-field">
                                        <v-select @input="inputLinea" label="nombre" :options="lineas" v-model="form.selectedLinea" id="linea" placeholder="Seleccione..."></v-select>
                                        <label for="linea">{{ $t('message.linea') }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field select2">
                                    <div class="form-group">
                                        <div class="select2-field">
                                            <v-select multiple v-model="form.types" id="types" :options="types"></v-select>
                                            <label for="types">{{ $t('message.tipoContenedor') }}</label>
                                            <span v-if="errores.types" class="helper-text text-danger" slot="helper">
                                                <strong>{{ errores.types[0] }}</strong>
                                            </span>
                                        </div>
                                        <label for="chkTiposContenedor">
                                            <input v-model="todos_tipos_contenedor" @change="changeTiposContenedor" type="checkbox" name="chkTiposContenedor" id="chkTiposContenedor"> <span>Todos</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field v-model="form.descripcion" id="descripcion">
                                        <span>{{ $t('message.descripcion') }}</span>
                                        <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.descripcion[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field v-model="form.abrev" id="abrev">
                                        <span>Abrev.</span>
                                        <span v-if="errores.abrev" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.abrev[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field select2">
                                    <div class="select2-field">
                                        <v-select :options="tiposUnidad" label="codigo" @input="inputTipoUnidad" id="tipoUnidad" v-model="selectedTipoUnidad"></v-select>
                                        <label for="tipoUnidad">{{ $t('message.tipo_unidad') }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field select">
                                    <div class="select-field">
                                        <select @input="inputValoracion" name="sts_type" id="sts_type" v-model="form.sts_type">
                                            <option v-if="form.tipo !== 'M'" value="PAR">{{ $t('message.parche') }}</option>
                                            <option value="POR">{{ $t('message.porcentaje') }}</option>
                                            <option value="CON">{{ $t('message.constante') }}</option>
                                        </select>
                                        <label for="sts_type">{{ $t('message.tipoValoracion') }}</label>
                                        <span v-if="errores.sts_type" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.sts_type[0] }}</strong>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field vMoney :format="decimal" v-model="form.horas_hombre" id="horas_hombre">
                                        <span>{{ $t('message.horas_hombre') }}</span>
                                        <span v-if="errores.horas_hombre" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.horas_hombre[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div v-show="form.selectedLinea !== null && form.selectedLinea.code === 'MSK'?true:false" class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field v-model="form.siglas" id="siglas">
                                        <span>{{ $t('message.siglasComa') }}</span>
                                        <span v-if="errores.siglas" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.siglas[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div v-show="form.tipo === 'M'" class="col-xs-12 col-md-6">
                                <div class="form-field select2">
                                    <div class="form-group">
                                        <div class="select2-field">
                                            <v-select id="modelosMaquina" multiple :options="tiposModelo" v-model="form.tipos_modelo"></v-select>
                                            <label for="modelosMaquina">{{ $t('message.tiposModelo') }}</label>
                                            <span v-if="errores.tipos_modelo" class="helper-text text-danger" slot="helper">
                                                <strong>{{ errores.tipos_modelo[0] }}</strong>
                                            </span>
                                        </div>
                                        <label for="chkModelosMaquina">
                                            <input v-model="todos_modelos_maquina" @change="changeModelosMaquina" type="checkbox" name="chkModelosMaquina" id="chkModelosMaquina"> <span>Todos</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div v-show="form.sts_type === 'CON'" class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field vMoney :format="money" v-model="form.valor" id="valor" placeholder="##.##">
                                        <span>{{ $t('message.valor') }}</span>
                                        <span v-if="errores.valor" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.valor[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field vMoney :format="decimal" v-model="form.maximo_piezas" id="valor" placeholder="##.##">
                                        <span>{{ $t('message.piezas') }}</span>
                                        <span v-if="errores.maximo_piezas" class="helper-text text-danger" slot="helper">
                                            <strong>{{ errores.maximo_piezas[0] }}</strong>
                                        </span>
                                    </input-field>
                                </div>
                            </div>
                            <div v-show="form.tipo === 'M'" class="col-xs-12 col-md-6">
                                <div class="form-field select2">
                                    <div class="form-group">
                                        <div class="select2-field">
                                            <v-select id="tipo_maquina" multiple :options="tiposMaquina" v-model="form.tipos_maquina"></v-select>
                                            <label for="tipo_maquina">{{ $t('message.tipos') }}</label>
                                        </div>
                                        <label for="chkTiposMaquina">
                                            <input v-model="todos_tipos_maquina" @change="changeTiposMaquina" type="checkbox" name="chkTiposMaquina" id="chkTiposMaquina"> <span>Todos</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-xs-12 col-md-6">
                        <div class="card">
                            <div class="card__title">
                                <h5>{{ $t('message.damages') }}</h5>
                            </div>
                            <div class="card__content">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <checked-listbox @input="inputDamages" label="nombre" :items="damages" name="damages[]" v-model="form.damages"></checked-listbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="form.tipo === 'M'" class="card mt-3">
                            <div class="card__title">
                                <h5>{{ $t('message.partes') }}</h5>
                            </div>
                            <div class="card__content">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <checked-listbox @input="inputMateriales" label="nombre" :items="materiales" name="materiales[]" v-model="form.materiales"></checked-listbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="card">
                            <div class="card__title">
                                <h5>{{ $t('message.modos') }}</h5>
                            </div>
                            <div class="card__content">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <checked-listbox @input="inputModos" label="nombre" :items="modos" name="modos[]" v-model="form.modos"></checked-listbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="form.sts_type !== 'CON'" class="card mt-3">
                            <div class="card__title">
                                <h5>{{ $t('message.valoracionArea') }}</h5>
                            </div>
                            <div class="card__content">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <tabla-areas :sts_type="form.sts_type" v-model="form.areas"></tabla-areas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="layout__main-buttons">
                <div class="card">
                    <div class="card__content">
                        <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-save"></i><span>{{ $t('message.guardar') }}</span></button>
                        <button @click="nuevo" class="btn-secondary btn--text" type="button"><i class="fa fa-plus"></i><span>{{ $t('message.nuevo') }}</span></button>
                        <button v-show="form.estado !== 'N'" @click="eliminar" :class="{
                            'btn-danger' : form.estado === 'A',
                            'btn-success' : form.estado === 'I'
                        }" class="btn--text" type="button"><i class="fa fa-ban"></i><span>{{ form.estado === 'A'?$t('message.desactivar2'):$t('message.activar2') }}</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        types : {
            required : false,
            default : function () {
                return [];
            }
        },
        tiposUnidad : {
            required : true,
            type : Array
        },
        value : {
            type : Object,
            required : false, 
            default : function () {
                return {
                    id : '',
                    codigo : '',
                    descripcion : '',
                    estado : 'N',
                    horas_hombre : 0,
                    nota : '',
                    selectedLinea : null,
                    modos : [],
                    materiales : [],
                    tipo : 'C',
                    damages : [],
                    valor : '',
                    maximo_piezas : 0,
                    tipo_unidad_id : '',
                    tipos_modelo : [],
                    siglas : '',
                    sts_type : 'CON',
                    types : [],
                    areas : [],
                    tipos_maquina : [],
                    abrev : ''
                };
            }
        },
        lineas : {
            type : Array,
            required : true
        },
        modos : {
            type : Array, 
            required : true
        },
        materiales : {
            type : Array, 
            required : false,
            default : function () {
                return [];
            }
        },
        sts : {
            type : Object,
            required : false,
            default : function () {
                return null;
            }
        }
    },
    computed : {
        editable : function () {
            return this.form.estado === 'N';
        }
    },
    data : function () {
        return {
            todos_modelos_maquina : false,
            todos_tipos_maquina : false,
            todos_tipos_contenedor : false,
            form : this.value,
            errores : {},
            url : url,
            decimal : decimal,
            damages : [],
            money : money,
            todasLineas : false,
            selectedTipoUnidad : null,
            inicial : true,
            tiposModelo : [
                'Carrier',
                'Thermo King',
                'Daikin',
                'Star Cool',
                'Super Freezer TK'
            ],
            tiposMaquina : [
                'PTI Largo',
                'PTI Corto',
                'RAPS',
                'CA'
            ]
        }
    },
    methods : {
        changeTiposContenedor : function () {
            this.form.types.splice(0, this.form.types.length);
            if (this.todos_tipos_contenedor) {
                for (let i = 0; i < this.types.length; i++)
                    this.form.types.push(this.types[i]);
            }
        },
        changeTiposMaquina : function () {
            this.form.tipos_maquina.splice(0, this.form.tipos_maquina.length);
            if (this.todos_tipos_maquina) {
                for (let i = 0; i < this.tiposMaquina.length; i++) 
                    this.form.tipos_maquina.push(this.tiposMaquina[i]);
            }
        },
        changeModelosMaquina : function () {
            this.form.tipos_modelo.splice(0, this.form.tipos_modelo.length);
            if (this.todos_modelos_maquina)
            {
                for (let i = 0; i < this.tiposModelo.length; i++)
                    this.form.tipos_modelo.push(this.tiposModelo[i]);
            }
        },
        eliminar : function () {
            let that = this;
            let enabled = this.form.estado === 'A';
            swal({
                title: (this.$t('message.deseas') + ' ' + (enabled?this.$t('message.desactivar'):this.$t('message.activar')) + ' ' + this.$t('message.esteRegistro') + ' ? '),
                text: this.$t('message.requiereConfirmacion'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: that.$t('message.confirmar'),
                cancelButtonText : that.$t('message.cancelar')
                }).then((result) => {
                    if (result.value) {
                        axios.post(that.url + '/sts/' + this.form.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                             swal(that.$t('message.elRegistro') + ' ' + (enabled?that.$t('message.desactivado'):that.$t('message.activado')) + '.', that.$t('message.aviso'), 'success');
                            that.form.estado = that.form.estado === 'A'?'I':'A';
                        });
                    }
                }).catch(function (error) {
                    if (error !== null && error !== undefined) {
                        let response = error.response;
                        if (response !== undefined && response !== null) {
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                        }
                    }
                });
        },
        nuevo : function () {
            let that = this;
            swal({
                title: (that.$t('message.formularioLimpiado')),
                text: that.$t('message.deseasCrear'),
                type: 'question',
                showCancelButton: true,
                confirmButtonText: that.$t('message.nuevo'),
                cancelButtonText : that.$t('message.cancelar')
                }).then((result) => {
                    if (result.value) {
                        this.form.id = '';
                        this.form.codigo = '';
                        this.form.descripcion = '';
                        this.form.estado = 'N';
                        this.form.selectedLinea = null;
                        this.form.horas_hombre = '';
                        this.form.areas.splice(0, this.form.areas.length);
                        this.form.modos.splice(0, this.form.modos.length);
                        this.form.damages.splice(0, this.form.damages.length);
                        this.form.materiales.splice(0, this.form.materiales.length);
                        this.form.tipo = 'C';
                        this.form.valor = '';
                        this.form.maximo_piezas = '';
                        this.form.tipo_unidad_id = '';
                        this.form.tipos_modelo = [];
                        this.form.siglas = '';
                        this.form.sts_type = 'CON';
                        this.form.types = [];
                        this.form.tipos_maquina = [];
                        this.todos_tipos_maquina = false;
                        this.form.abrev = '';
                        this.todos_modelos_maquina = false;
                        this.todos_tipos_contenedor = false;
                        this.cambiarTipo();
                        this.selectedTipoUnidad = null;
                    }
                });
            
        },
        inputValoracion : function () {
            if (this.form.sts_type !== 'CON')
            {
                this.form.valor = '';
                this.form.areas.splice(0, this.form.areas.length);
            }
        },
        inputDamages : function (value) {
            this.form.damages = value;
        },
        inputLinea : function () {
            if (!this.inicial)
            {
                if (this.form.selectedLinea === null || this.form.selectedLinea.codigo !== 'MSK')
                    this.form.siglas = '';
                    this.inicial = true;
            }
        },
        inputModos : function (value) {
            this.form.modos = value;
        },
        inputMateriales : function (value) {
            this.form.materiales = value;
        },
        inputTipoUnidad : function () {
            if (this.selectedTipoUnidad !== null) 
                this.form.tipo_unidad_id = this.selectedTipoUnidad.id;
            else 
                this.form.tipo_unidad_id = '';
        },
        changeTodasLineas : function () {
            if (this.todasLineas)
                this.form.selectedLinea = null;
        },
        aceptar : function () {
            let that = this;
            let urlRequest = this.url + '/sts';
            if (this.form.estado !== 'N')
            {
                urlRequest += '/' + this.form.id;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            axios.post(urlRequest, this.form).then(function (response) {
                swal(that.$t('message.saved'), that.$t('message.aviso'), 'success');
                that.editarSts(response.data);
                that.$emit('saved', response.data);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal(that.$t('message.errorValidacion'), that.$t('message.aviso'), 'warning');
                        }
                        else 
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                    }
                }
            })
        },
        cambiarTipo : function () {
            if (this.form.tipo !== null && this.form.tipo !== '') {
                let that = this;
                axios.get(this.url + '/damages/' + that.form.tipo).then(function (response) {
                    if (that.editable)
                        that.form.damages = [];
                    that.damages = response.data;
                });
                if (that.form.tipo === 'C')
                    that.form.materiales = [];
            }
        },
        editarSts : function (sts) {
            let row = sts;
            this.form.id = row.id;
            this.form.codigo = row.codigo;
            this.form.descripcion = row.descripcion;
            this.form.estado = row.estado;
            this.form.selectedLinea = row.linea;
            this.form.horas_hombre = row.horas_hombre;
            this.form.areas.splice(0, this.form.areas.length);
            this.form.modos.splice(0, this.form.modos.length);
            this.form.damages.splice(0, this.form.damages.length);
            this.form.materiales.splice(0, this.form.materiales.length);
            this.form.tipo = row.tipo;
            this.form.valor = row.valor;
            this.form.maximo_piezas = row.maximo_piezas;
            this.form.tipo_unidad_id = row.tipo_unidad_id;
            this.form.tipos_modelo = row.tipos_modelo !== null?row.tipos_modelo.split(','):[];
            this.form.siglas = row.siglas;
            this.form.sts_type = row.sts_type;
            this.form.types = row.types;
            this.form.tipos_maquina = row.tipos_maquina;
            this.form.abrev = row.abrev;
            for (let i = 0; i < row.modos.length; i++)
                this.form.modos.push(row.modos[i].modo_id);
            for (let i = 0; i < row.materiales.length; i++)
                this.form.materiales.push(row.materiales[i].material_id);
            for (let i = 0; i < row.damages.length; i++)
                this.form.damages.push(row.damages[i].damage_id);
            for (let i = 0; i < row.areas.length; i++)
                this.form.areas.push({
                    area : row.areas[i].area,
                    valor : row.areas[i].valor,
                    hora_trabajo : row.areas[i].hora_trabajo
                });
        }
    },
    created : function () {
        if (this.sts !== null) 
            this.editarSts(this.sts);
    },
    mounted : function () {
        this.cambiarTipo();
        if (this.form.selectedLinea === null)
            this.todasLineas = true;
        if (this.form.tipo_unidad_id !== '')
            for (let i = 0; i < this.tiposUnidad.length; i++) 
                if (this.tiposUnidad[i].id == this.form.tipo_unidad_id) {
                    this.selectedTipoUnidad = this.tiposUnidad[i];
                    break;
                }
        if (this.form.selectedLinea !== null)
            for (let i = 0; i < this.lineas.length; i++)
                if (this.form.selectedLinea.id == this.lineas[i])
                {
                    this.form.selectedLinea = this.lineas[i];
                    break;
                }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/sts/Sts.vue